import { Loadable } from 'utils/components';
import { EMAIL_VERIFICATION as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'EmailVerification' */ './components/EmailVerificationPage')
  })
};
